import { render, staticRenderFns } from "./AddNewPropertyButton.vue?vue&type=template&id=953c50b2&scoped=true&"
import script from "./AddNewPropertyButton.vue?vue&type=script&lang=js&"
export * from "./AddNewPropertyButton.vue?vue&type=script&lang=js&"
import style0 from "./AddNewPropertyButton.vue?vue&type=style&index=0&id=953c50b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953c50b2",
  null
  
)

export default component.exports